'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 52.805h60V0H0z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement(
                'mask',
                {
                    id: 'b',
                    fill: '#fff'
                },
                _react2.default.createElement('use', {
                    xlinkHref: '#a'
                })
            ),
            _react2.default.createElement('path', {
                d: 'M52.5 25.164h-1.875v-2.923c0-1.566-1.262-2.84-2.813-2.84H19.689V17.51h28.125c2.584 0 4.687 2.123 4.687 4.732v2.923z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M1.875 5.484H7.5v-.751c0-1.567-1.262-2.84-2.813-2.84-1.55 0-2.812 1.273-2.812 2.84v.751zm29.06 45.429h24.378c1.55 0 2.812-1.274 2.812-2.84v-.195h-26.25v.195c0 1.065-.35 2.048-.94 2.84zm24.378 1.892H27.186c-2.584 0-4.687-2.122-4.687-4.732V22.241c0-1.566-1.262-2.839-2.813-2.839-1.55 0-2.812 1.273-2.812 2.84v9.742c0 2.61-2.103 4.732-4.688 4.732-2.584 0-4.687-2.123-4.687-4.732V7.377H0V4.733C0 2.123 2.103 0 4.688 0c2.584 0 4.687 2.123 4.687 4.733v27.251c0 1.565 1.262 2.84 2.813 2.84 1.55 0 2.812-1.275 2.812-2.84v-9.743c0-2.609 2.103-4.732 4.688-4.732 2.584 0 4.687 2.123 4.687 4.732v25.832c0 1.566 1.262 2.84 2.813 2.84 1.55 0 2.812-1.274 2.812-2.84v-2.088h30v2.088c0 2.61-2.103 4.732-4.688 4.732z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M37.5 9.27h-1.875V4.733c0-1.567-1.262-2.84-2.813-2.84H4.689V0h28.125C35.397 0 37.5 2.123 37.5 4.733V9.27zM12.188 36.716h11.25v-1.893h-11.25z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                mask: 'url(#b)',
                d: 'M30.938 31.038h13.125v-1.893H30.937zM30.938 34.823h13.125V32.93H30.937zM30.938 38.609h13.125v-1.893H30.937z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFEDBB',
                mask: 'url(#b)',
                d: 'M15.938 12.109h13.124v-1.893H15.938zM15.938 15.895h13.124v-1.893H15.938z'
            }),
            _react2.default.createElement('path', {
                d: 'M33.75 12.109a.944.944 0 0 0-.938.946c0 .522.421.947.938.947h18.362l.937-.947-.937-.946H33.75zm19.138 3.786H33.75c-1.55 0-2.813-1.274-2.813-2.84 0-1.565 1.262-2.839 2.813-2.839h19.138l2.813 2.84-2.813 2.839z',
                fill: '#00D8C8',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#A7F2EB',
                mask: 'url(#b)',
                d: 'M42.188 8.323h1.874V6.43h-1.874zM45.938 8.323h1.874V6.43h-1.874zM49.688 8.323h1.874V6.43h-1.874zM7.5 40.502h1.875v-1.893H7.5zM11.25 40.502h1.875v-1.893H11.25zM15 40.502h1.875v-1.893H15z'
            }),
            _react2.default.createElement('path', {
                d: 'M48.75 42.395h9.375v-13.25H48.75v13.25zm-1.875 1.893H60V27.252H46.875v17.036z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#00D8C8',
                mask: 'url(#b)',
                d: 'M50.625 40.502H52.5v-1.893h-1.875zM54.375 40.502h1.875v-1.893h-1.875zM50.625 36.716H52.5v-1.893h-1.875zM54.375 36.716h1.875v-1.893h-1.875z'
            }),
            _react2.default.createElement('path', {
                fill: '#A7F2EB',
                mask: 'url(#b)',
                d: 'M50.625 32.93h5.625v-1.892h-5.625z'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '60',
    height: '53',
    viewBox: '0 0 60 53',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;